<!-- src/views/OfficerGroupsView.vue -->
<template>
    <div class="container-fluid p-4">

        <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
            <h1 class="page-title fw-normal text-secondary mb-0">Officer Groups</h1>
        </div>

        <span v-if="isDataFetched" class="d-flex justify-content-center">
            <div class="spinner-border text-primary">
                <span class="visually-hidden"></span>
            </div>
             Loading...
        </span>

        <div class="row g-3">
            <!-- Add Group card -->
            <div class="col-12 col-lg-3">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <label class="form-label fw-semibold">Officer Group Name</label>
                        <input type="text" class="form-control mb-3" v-model="newGroupName" placeholder="Group name">

                        <label class="form-label fw-semibold">Branch</label>
                        <select class="form-select mb-3" v-model="newGroupBranchId">
                            <option :value="null">-- None --</option>
                            <option v-for="branch in branches" :key="branch.id" :value="branch.id">{{branch.name}}</option>
                        </select>

                        <button type="button" class="btn btn-success w-100" @click="AddGroup()" :disabled="!newGroupName">SAVE</button>
                    </div>
                </div>
            </div>

            <!-- Groups table -->
            <div class="col-12 col-lg-9">
                <div class="card shadow-sm">
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table text-left table-hover mb-0 align-middle groups-table">
                                <thead>
                                    <tr class="table-light">
                                        <th>Group ID</th>
                                        <th>Group Name</th>
                                        <th>Branch</th>
                                        <th>Members</th>
                                        <th class="text-end">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="group in groups" :key="group.officerGroupId">
                                        <td>{{group.officerGroupId}}</td>
                                        <td>{{group.groupName}}</td>
                                        <td>{{group.branchName || "-"}}</td>
                                        <td>{{group.officerIds.length}}</td>
                                        <td class="text-end text-nowrap">
                                            <div class="d-inline-flex flex-nowrap gap-2">
                                                <button type="button" class="btn btn-success action-btn" title="View Group Employees" @click="ViewGroupEmployees(group)">
                                                    <i class="bi bi-folder2-open"></i>
                                                </button>
                                                <button type="button" class="btn btn-primary action-btn" title="Edit" @click="ShowUpdateModal(group)">
                                                    <i class="bi bi-pencil"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger action-btn" title="Delete" @click="QuickDeleteGroup(group)">
                                                    <i class="bi bi-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="!isDataFetched && groups.length === 0">
                                        <td colspan="5" class="text-center text-muted py-3">No officer groups yet</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-primary collapse" id="groupDetailModalButton" data-bs-toggle="modal" data-bs-target="#groupDetailModal">
        Launch groupDetailModal
        </button>

        <div class="modal" id="groupDetailModal" tabindex="999999">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-align-center text-primary fw-bold" id="groupDetailModalLabel">Edit Officer Group</h4>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">

                        <div class="row p-2 m-2 modal-body text-left">
                            <div class="row mb-2">
                                <span class="text-primary col-3">Name </span>
                                <input type="text" class="text-danger col-9" v-model="selectedGroup.groupName" placeholder="Enter Group Name ">
                            </div>
                            <div class="row mb-2">
                                <span class="text-primary col-3">Branch </span>
                                <select class="col-9" v-model="selectedGroup.branchId">
                                    <option :value="null">-- None --</option>
                                    <option v-for="branch in branches" :key="branch.id" :value="branch.id">{{branch.name}}</option>
                                </select>
                            </div>
                            <div class="row mb-2">
                                <span class="text-primary col-3">Active </span>
                                <input type="checkbox" class="col-9" v-model="selectedGroup.isActive">
                            </div>
                            <div class="row">
                                <span class="text-primary col-3">Officers </span>
                                <div class="col-9">
                                    <Multiselect
                                        v-model="selectedGroup.officerIds"
                                        mode="tags"
                                        :close-on-select="false"
                                        :searchable="true"
                                        :options="officers.map(o => ({ value: o.id, label: o.name }))"
                                        placeholder="Select officers..."
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" @click="DeleteGroup()" class="btn btn-danger">Delete Group</button>
                        <button type="button" @click="UpdateGroup()" class="btn btn-secondary" data-bs-dismiss="modal">Update Group</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { toRaw } from 'vue';
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'

export default({
name:'OfficerGroupsView',
components: { Multiselect },
props:{
    baseUrl:String
},
data() {
    return {
        groups:[],
        officers:[],
        branches:[],
        isDataFetched:false,
        selectedGroup:{},
        newGroupName:"",
        newGroupBranchId:null,
        isModalAlreadyOpened:false
    }
},
methods:{
    loadOfficersFromLookupData(){
        const cachedData = localStorage.getItem("lookupData");
        if (!cachedData) return;
        const data = JSON.parse(cachedData);
        this.officers = (data.officers || []).map(o => ({ id: o.id, name: o.name }));
    },
    getBranchesList(){
        let branchesRequestUrl = this.baseUrl + "Branches/GetAll";
        let branchesRequestOptions = {
            method:"GET",
            headers:{
              "Authorization":"Bearer " + localStorage.token,
              "Content-Type" : "application/json"
            },
          };

          fetch(branchesRequestUrl, branchesRequestOptions)
          .then(response => response.json())
          .then(res =>{
            this.branches = (res.branches || []).map(b => ({ id: b.branchId, name: b.branchName }));
          })
          .catch(error=>{
            console.log("error encountered", error);
          });
    },
    getGroupsList(){
        this.isDataFetched = true;
        let groupsRequestUrl = this.baseUrl + "OfficerGroups/GetAll";
        let groupsRequestOptions = {
            method:"GET",
            headers:{
              "Authorization":"Bearer " + localStorage.token,
              "Content-Type" : "application/json"
            },
          };

          fetch(groupsRequestUrl, groupsRequestOptions)
          .then(response =>{
            return response.json();
          })
          .then(res =>{
            this.groups = res.groups;
            this.isDataFetched = false;
          })
          .catch(error=>{
            error = null;
            console.log("error encountered", error);
            this.isDataFetched = false;
          });
    },
    AddGroup(){
        if(!this.newGroupName) return;

        let addGroupRequestUrl = this.baseUrl + "OfficerGroups/Add";
        let addGroupRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "officerGroupId" : 0,
                    "groupName": this.newGroupName,
                    "isActive": true,
                    "branchId": this.newGroupBranchId,
                    "officerIds": []
                }
            )
        };

        fetch(addGroupRequestUrl, addGroupRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                this.newGroupName = "";
                this.newGroupBranchId = null;
                await this.getGroupsList();
            }
            else{
                alert("Failed to add group. Please try again.");
                console.error("Add error:", result);
            }
        })
        .catch(error=>{
            console.error("Add failed:", error);
            alert("An error occurred while adding the group.");
        });
    },
    UpdateGroup(){
        let updateGroupRequestUrl = this.baseUrl + "OfficerGroups/Update";
        let updateGroupRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "officerGroupId" : this.selectedGroup.officerGroupId,
                    "groupName": this.selectedGroup.groupName,
                    "isActive": this.selectedGroup.isActive,
                    "branchId": this.selectedGroup.branchId,
                    "officerIds": toRaw(this.selectedGroup.officerIds) || []
                }
            )
        };

        fetch(updateGroupRequestUrl, updateGroupRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("Officer Group updated successfully!");
                await this.getGroupsList();
            }
            else{
                alert("Failed to update group. Please try again.");
                console.error("Update error:", result);
            }
        })
        .catch(error=>{
            console.error("Update failed:", error);
            alert("An error occurred while updating the group.");
        });
    },
    DeleteGroup(){
        if(!confirm("Delete group '" + this.selectedGroup.groupName + "'? Its officers will be unassigned, not deleted.")){
            return;
        }
        this.deleteGroupById(this.selectedGroup.officerGroupId, () => {
            document.getElementById("groupDetailModalButton").click();
        });
    },
    QuickDeleteGroup(group){
        if(!confirm("Delete group '" + group.groupName + "'? Its officers will be unassigned, not deleted.")){
            return;
        }
        this.deleteGroupById(group.officerGroupId);
    },
    deleteGroupById(officerGroupId, onSuccess){
        let deleteGroupRequestUrl = this.baseUrl + "OfficerGroups/Delete";
        let deleteGroupRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "Id": officerGroupId
                }
            )
        };

        fetch(deleteGroupRequestUrl, deleteGroupRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("Officer Group deleted successfully!");
                if(onSuccess) onSuccess();
                await this.getGroupsList();
            }
            else{
                alert(result.details || "Failed to delete group. Please try again.");
                console.error("Delete error:", result);
            }
        })
        .catch(error=>{
            console.error("Delete failed:", error);
            alert("An error occurred while deleting the group.");
        });
    },
    ViewGroupEmployees(group){
        this.$router.push(`/officerGroups/${group.officerGroupId}`);
    },
    ShowUpdateModal(group){
        this.selectedGroup = { ...toRaw(group), officerIds: [...toRaw(group).officerIds] };

        document.getElementById("groupDetailModalButton").click();
    }
},
mounted(){
    this.loadOfficersFromLookupData();
    this.getBranchesList();
    this.getGroupsList();

    const groupDetailModalEl = document.getElementById('groupDetailModal')
    groupDetailModalEl.addEventListener('shown.bs.modal', event => {
        this.isModalAlreadyOpened = true;
    });
    groupDetailModalEl.addEventListener('hidden.bs.modal', async event => {
        this.isModalAlreadyOpened = false;
        await this.getGroupsList();
    });
},

})
</script>
<style scoped>
.page-title {
    font-size: 1.75rem;
}
.groups-table {
    width: auto;
    min-width: 100%;
}
.groups-table thead th {
    font-size: 1.05rem;
    font-weight: 600;
    color: #6c757d;
    padding: 0.75rem 1.25rem;
    white-space: nowrap;
}
.groups-table tbody td {
    font-size: 1.05rem;
    padding: 0.75rem 1.25rem;
    white-space: nowrap;
}
.groups-table td:nth-child(2) {
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.groups-table td:last-child {
    width: 1%;
}
.action-btn {
    width: 2.375rem;
    height: 2.375rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}
</style>
